import React, { useState } from "react";
import { useFormikContext } from "formik";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import AssetQuantityField from "src/views/inventory/requests/AssetQuantityField";
import { getInitialLocation } from "./utils";

export default function DuplicateLocationsModal({ index, onClose }) {
  const { values, setFieldValue } = useFormikContext();
  const [locationsToAdd, setLocationsToAdd] = useState(1);

  const handleSubmit = () => {
    const locations = values.locations;
    const count = Number(locationsToAdd) || 0;

    if (!locations || typeof index !== "number" || count < 1) {
      onClose();
      return;
    }

    const sourceLocation = locations[index];

    if (!sourceLocation) {
      onClose();
      return;
    }

    const totalQuantity = (sourceLocation.sub_qty || 0) + (sourceLocation.restock_sub_qty || 0);
    const baseLocation = getInitialLocation(totalQuantity, sourceLocation.shipment_id);

    const duplicates = Array.from({ length: count }, () => ({
      ...baseLocation,
      warehouse: sourceLocation.warehouse,
      warehouse_locations: sourceLocation.warehouse_locations || [],
      ...(sourceLocation.mobile_warehouse_location && {
        mobile_warehouse_location: sourceLocation.mobile_warehouse_location,
      }),
    }));

    const newLocations = [
      ...locations.slice(0, index + 1),
      ...duplicates,
      ...locations.slice(index + 1),
    ];

    setFieldValue("locations", newLocations);
    onClose();
  };

  const isSubmitDisabled = (Number(locationsToAdd) || 0) < 1;

  return (
    <Dialog open onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Box position="relative">
          <Typography fontSize={22} fontWeight={500} color="text.primary" align="center">
            Duplicate Locations
          </Typography>
          <IconButton
            onClick={onClose}
            size="small"
            sx={{ position: "absolute", right: 0, top: 0 }}
          >
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Typography gutterBottom align="center">
          How many total locations would you like to add?
        </Typography>
        <Box mt={4} display="flex" justifyContent="center">
          <AssetQuantityField
            quantity={locationsToAdd}
            onChange={setLocationsToAdd}
            quantityProps={{
              label: "Total Locations",
              style: { minWidth: 160 },
              autoFocus: true,
              InputLabelProps: {
                shrink: true,
              },
            }}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button variant="outlined" onClick={onClose}>
          Cancel
        </Button>
        <Button
          disabled={isSubmitDisabled}
          variant="contained"
          color="primary"
          onClick={handleSubmit}
        >
          Add
        </Button>
      </DialogActions>
    </Dialog>
  );
}
